import React from 'react';

const WorkSchedule = ({ fontStyles }) => {
  const scheduleData = [
    { day: 'MONDAY', hours: '12PM - 9PM' },
    { day: 'TUESDAY', hours: '10AM - 9PM' },
    { day: 'WEDNESDAY', hours: '11AM - 9PM' },
    { day: 'THURSDAY', hours: '11AM - 9PM' },
    { day: 'FRIDAY', hours: '11AM - 9PM' },
    { day: 'SATURDAY', hours: '10AM - 6PM' },
    { day: 'SUNDAY', hours: '10AM - 6PM' },
  ];

  // Styles for day names
  const dayStyle = {
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '156%', /* 31.2px */
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
  };

  // Styles for timing
  const timeStyle = {
    color: '#000',
    textAlign: 'right',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '100%', /* 20px */
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
  };

  return (
    <div className="mb-8 lg:mb-12 px-4 sm:px-0">
      {/* All days */}
      {scheduleData.map((schedule, index) => (
        <div key={index} className="mb-4">
          <div className="flex justify-between items-baseline mb-3">
            <h4 style={dayStyle}>
              {schedule.day}
            </h4>
            <span style={timeStyle}>
              {schedule.hours}
            </span>
          </div>
          <div 
            className="border-b"
            style={{
              borderColor: '#e0e0e0',
              borderBottomWidth: '1px',
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};

// Export both versions
export { WorkSchedule };
export default WorkSchedule;